module.exports = __webpack_public_path__ + "static/media/128.6bafc263.png";